import styled from 'styled-components';
import { media } from 'src/styles/designs';
import { ExpandButton } from 'src/components/common/ExpandableContent/ExpandButton';
import { dirRTL } from 'src/styles/theme';
import { AnimatePresence } from 'framer-motion';
import { ExpandTransition } from 'src/components/common/ExpandTransition';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';

export interface EventPageAgendaTimeslotDescriptionProps {
  description: string;
  isExpanded: boolean;
  toggleIsExpanded: () => void;
}

const Container = styled.div`
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
  color: ${({ theme }) => theme.text.palette.primary};
  margin-bottom: -24px;
  span {
    display: block;
    padding-bottom: 20px;
  }
  ${media.w.lessThan.desktop} {
    margin-bottom: -14px;
    font-size: 14px;
    line-height: 21px;
  }
`;

const StyledExpandButton = styled(ExpandButton)`
  ${media.w.lessThan.desktop} {
    padding: 6px;
    margin-right: -20px;
    margin-top: -20px;
    ${dirRTL} {
      margin-right: 0;
      margin-left: -20px;
    }
    & > p {
      display: none;
    }
  }
`;

const Description = styled.div`
  margin-top: 16px;
`;

export const EventPageAgendaTimeslotDescription = ({
  description,
  isExpanded,
  toggleIsExpanded,
}: EventPageAgendaTimeslotDescriptionProps) => {
  return (
    <Container>
      <StyledExpandButton active={isExpanded} onClick={toggleIsExpanded} />
      <AnimatePresence initial={false}>
        {isExpanded && (
          <ExpandTransition key="content">
            <Description>
              <Markdown>{description}</Markdown>
            </Description>
          </ExpandTransition>
        )}
      </AnimatePresence>
    </Container>
  );
};
